export enum regionsTypes {
  FETCH_REGIONS_REQUEST = "FETCH_REGIONS_REQUEST",
  FETCH_REGIONS_SUCCESS = "FETCH_REGIONS_SUCCESS",
  FETCH_REGIONS_FAILURE = "FETCH_REGIONS_FAILURE",
}